import { useRef, useEffect } from 'react';

export type CaptureMode = 'camera' | 'gallery';

interface CameraCaptureProps {
  onCapture: (file: File) => void;
  onClose?: () => void;
  mode?: CaptureMode;
}

const ACCEPTED_IMAGE_TYPES = 'image/jpeg,image/png,image/webp,image/heic,image/heif,image/gif';

export function CameraCapture({ onCapture, onClose, mode = 'camera' }: CameraCaptureProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    fileInputRef.current?.click();
  }, []);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) {
      onClose?.();
      return;
    }
    onCapture(files[0]);
  };

  return (
    <input
      ref={fileInputRef}
      type="file"
      accept={ACCEPTED_IMAGE_TYPES}
      {...(mode === 'camera' ? { capture: 'environment' } : {})}
      onChange={handleFileChange}
      className="hidden"
    />
  );
}
